import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs },
}: { BreakpointNames: { xs: string; sm: string; md: string } } =
  constants.breakpoints;

const {
  colors: { ui },
} = constants;

const neutral100 = constants.colors.ui.neutral[100];
const neutral700 = constants.colors.ui.neutral[700];

const { fontFamily, fontSize } = typographyStyles;

export const modalContainerCss = {
  zIndex: 999,
  width: "100%",
};

export const modalContentCss = {
  width: "100%",
  maxWidth: "95%",
  backgroundColor: ui.white[50],
  boxShadow: "0px 16px 40px rgba(0, 0, 0, 0.32)",
  borderRadius: "8px",
  paddingBlock: "8px",
  paddingInline: "32px",
  height: "auto",
  maxHeight: "90%",
  zIndex: 999,

  [mq.upTo(xs)]: {
    paddingInline: "16px",
  },
};

export const modalTitleCss: CSSObject = {
  ...fontFamily.noto,
  ...fontSize.heading3,
  fontWeight: 700,
  color: ui.neutral[700],
};

export const modalHeaderCss = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  borderBottom: `1px solid ${neutral100}`,
};

export const headerTitleCss: CSSObject = {
  ...fontFamily.noto,
  ...fontSize.heading3,
  fontWeight: 700,
  color: neutral700,
};

export const closeButtonCss: CSSObject = {
  alignSelf: "center",
  color: neutral700,
  "& svg": {
    height: "27px",
  },
};
